import { EOfficeType } from '../../api-models/common/json_query';

export const TRADE_AREA_GROUP: EOfficeType[] = [
  EOfficeType.TradeArea,
  EOfficeType.FreeAppointmentObject,
  EOfficeType.PublicCatering,
  EOfficeType.AutoService,
  EOfficeType.DomesticServices,
  EOfficeType.Building,
  EOfficeType.Business,
];

export const WAREHOUSE_GROUP: EOfficeType[] = [EOfficeType.Warehouse, EOfficeType.Manufacture];
